<template>
  <div class="vc-flex" style="justify-content: center;">
     <div @click="saveClick" class="bntsave focus-s">保存</div>
     <div :style="{'width':space+'px'}"></div>
     <div @click="cancelClick" class="bntcancel focus-s">取消</div>
  </div>
</template>

<script>
export default {
  name: 'SaveButton',
  props: {
    space:{
      type:Number,
      default:70
    }
  },
  methods:{
    ///保存按钮
    saveClick:function(){
        this.$emit("buttonClick",true)
    },
    ///取消按钮
    cancelClick:function(){
        this.$emit("buttonClick",false)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bntsave{
    background: var(--ek-color-primary);
    color: white;
    padding-left: 50px;
    padding-right: 50px;
    line-height: 38px;
    border-radius: 5px;
}
.bntcancel{
    background: rgb(110 110 110);
    color: white;
    padding-left: 50px;
    padding-right: 50px;
    line-height: 38px;
    border-radius: 5px;
}
</style>
